var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoListingFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 694.95 675.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #d5d5d5;\n      }\n\n      .cls-1, .cls-3, .cls-4 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-5, .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-7 {\n        fill: #d1d2d1;\n      }\n\n      .cls-8 {\n        fill: #f05b26;\n      }\n\n      .cls-9 {\n        fill: #dd5126;\n      }\n\n      .cls-10 {\n        fill: #f5f5f5;\n      }\n\n      .cls-11 {\n        isolation: isolate;\n      }\n\n      .cls-12 {\n        fill: #fbe9be;\n        mix-blend-mode: overlay;\n        opacity: .33;\n      }\n\n      .cls-6 {\n        opacity: .26;\n      }\n\n      .cls-13 {\n        opacity: .05;\n      }\n\n      .cls-14, .cls-4 {\n        fill: #e6e6e6;\n      }\n\n      .cls-15, .cls-16 {\n        fill: #bbbcbb;\n      }\n\n      .cls-17, .cls-18 {\n        fill: #f3f2f2;\n      }\n\n      .cls-19 {\n        fill: #efeeed;\n      }\n\n      .cls-20 {\n        fill: #475151;\n      }\n\n      .cls-21 {\n        fill: #303838;\n      }\n\n      .cls-16, .cls-18 {\n        fillRule: evenodd;\n      }\n\n      .cls-3 {\n        fill: #e3e2df;\n        opacity: .72;\n      }\n\n      .cls-22 {\n        fill: #252b2b;\n      }\n\n      .cls-23 {\n        fill: #a9c0c9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 347.48,
    cy: 337.8,
    r: 337.8,
    transform: "translate(-137.09 344.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M630.07,526.91c0,11.69-9.47,21.16-21.16,21.16H86.05c-11.69,0-21.16-9.47-21.16-21.16V225.83c0-11.68,9.47-21.16,21.16-21.16H608.91c11.69,0,21.16,9.47,21.16,21.16v301.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M64.89,520.99v8.67c0,10.17,9.47,18.41,21.16,18.41H608.91c11.69,0,21.16-8.24,21.16-18.41v-8.67H64.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M694.95,528.28H0v20.62c8.25,12.29,28.31,21.06,38.61,21.06H656.48c10.22,0,30.15-8.69,38.47-20.89v-20.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M.37,549.53c8.5,11.96,28.06,20.44,38.18,20.44H656.42c10.1,0,29.65-8.48,38.16-20.44H.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M288.93,528.81c.65,7.96,7.3,14.23,15.44,14.23h86.23c8.13,0,14.79-6.27,15.44-14.23h-117.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "125.22 226.64 98.38 226.64 98.38 501.87 596.57 501.87 596.57 464.31 125.22 226.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "596.57 226.64 125.22 226.64 596.57 464.31 596.57 226.64"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.56,
    y: 275.42,
    width: 473.83,
    height: 206.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.56,
    y: 275.42,
    width: 473.83,
    height: 34.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.56,
    y: 275.42,
    width: 473.83,
    height: 16.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 93.64,
    y: 141.14,
    width: 507.67,
    height: 135.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 146.63,
    y: 303.03,
    width: 45.62,
    height: 38.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.63,
    y: 303.03,
    width: 5.97,
    height: 38.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 146.63,
    y: 303.03,
    width: 45.62,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 146.63,
    y: 307.38,
    width: 45.62,
    height: 1.63
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 146.63,
    y: 358.71,
    width: 45.62,
    height: 38.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.63,
    y: 358.71,
    width: 5.97,
    height: 38.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 146.63,
    y: 358.71,
    width: 45.62,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 146.63,
    y: 363.05,
    width: 45.62,
    height: 1.63
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 146.63,
    y: 414.38,
    width: 45.62,
    height: 38.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.63,
    y: 414.38,
    width: 5.97,
    height: 38.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 146.63,
    y: 414.38,
    width: 45.62,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 146.63,
    y: 418.73,
    width: 45.62,
    height: 1.63
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 502.7,
    y: 303.03,
    width: 45.63,
    height: 38.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 542.35,
    y: 303.03,
    width: 5.97,
    height: 38.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 502.7,
    y: 303.03,
    width: 45.63,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 502.7,
    y: 307.38,
    width: 45.63,
    height: 1.63
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 502.7,
    y: 358.71,
    width: 45.63,
    height: 38.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 542.35,
    y: 358.71,
    width: 5.97,
    height: 38.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 502.7,
    y: 358.71,
    width: 45.63,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 502.7,
    y: 363.05,
    width: 45.63,
    height: 1.63
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 502.7,
    y: 414.38,
    width: 45.63,
    height: 38.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 542.35,
    y: 414.38,
    width: 5.97,
    height: 38.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 502.7,
    y: 414.38,
    width: 45.63,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 502.7,
    y: 418.73,
    width: 45.63,
    height: 1.63
  }))))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "312.3 262.3 470.14 262.3 584.38 411.48 584.39 481.71 465.25 481.71 312.3 262.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "347.48 152.84 217.15 262.71 477.81 262.71 347.48 152.84 217.15 262.71 477.81 262.71 347.48 152.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "347.48 166.05 245.57 251.95 449.38 251.95 347.48 166.05 245.57 251.95 449.38 251.95 347.48 166.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 218.69,
    y: 264.37,
    width: 257.57,
    height: 214.18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M296.08,451.29v-133.51c0-16.72-12.4-30.27-27.7-30.27h-3.32c-15.3,0-27.7,13.56-27.7,30.27v133.51h58.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M268.38,287.5h-3.32c-.89,0-1.76,.05-2.62,.14,14.07,1.45,25.08,14.39,25.08,30.14v133.51h8.57v-133.51c0-16.72-12.4-30.27-27.7-30.27Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M376.84,451.29v-133.51c0-16.72-12.4-30.27-27.7-30.27h-3.32c-15.3,0-27.7,13.56-27.7,30.27v133.51h58.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M349.14,287.5h-3.32c-.88,0-1.76,.05-2.62,.14,14.07,1.45,25.08,14.39,25.08,30.14v133.51h8.56v-133.51c0-16.72-12.4-30.27-27.7-30.27Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M457.6,451.29v-133.51c0-16.72-12.4-30.27-27.7-30.27h-3.32c-15.3,0-27.7,13.56-27.7,30.27v133.51h58.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M429.9,287.5h-3.32c-.88,0-1.76,.05-2.62,.14,14.07,1.45,25.08,14.39,25.08,30.14v133.51h8.57v-133.51c0-16.72-12.4-30.27-27.7-30.27Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 216.3,
    y: 261.65,
    width: 262.63,
    height: 6.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 345.39,
    y: 43.42,
    width: 4.17,
    height: 111.24
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "416.5 61.95 416.5 104.92 416.56 104.92 450.08 61.95 416.5 61.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "450.09 104.92 416.22 104.92 416.5 61.95 416.58 61.95 450.09 104.92"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 349.57,
    y: 43.42,
    width: 77.24,
    height: 43.44
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "416.22 86.71 416.22 104.93 426.81 86.71 416.22 86.71"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "361.54 43.42 388 86.86 404.7 86.86 378.23 43.42 361.54 43.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "414.97 86.86 388.5 43.42 381.85 43.42 408.32 86.86 414.97 86.86"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.2,
    y: 443.99,
    width: 234.55,
    height: 6.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 230.2,
    y: 449.53,
    width: 234.55,
    height: 6.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.2,
    y: 455.07,
    width: 234.55,
    height: 6.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 230.2,
    y: 460.61,
    width: 234.55,
    height: 6.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.37,
    y: 464.41,
    width: 280.21,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 207.37,
    y: 471.03,
    width: 280.21,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.37,
    y: 477.65,
    width: 280.21,
    height: 7.52
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M349.27,236.38h-3.2v-5.06c-5.84-.63-9.58-3.36-11.22-8.2l3.54-1.39c1.36,3.69,3.92,5.69,7.68,6v-12.17c-4.07-.98-6.72-2.25-7.93-3.83-1.22-1.57-1.82-3.32-1.82-5.24,0-5.07,3.25-8.14,9.75-9.23v-4.33h3.2v4.33c5.16,.46,8.54,2.76,10.14,6.92l-3.54,1.15c-.96-2.85-3.17-4.39-6.61-4.61v11.22c7.22,1.29,10.83,4.55,10.83,9.75,0,2.24-.82,4.31-2.46,6.23-1.65,1.91-4.43,3.05-8.37,3.39v5.06Zm-3.2-35.66c-1.8,.14-3.24,.69-4.31,1.66-1.08,.96-1.61,2.18-1.61,3.65,0,2.89,1.97,4.71,5.92,5.47v-10.78Zm3.2,27c2.12-.09,3.78-.67,4.98-1.76,1.19-1.08,1.79-2.39,1.79-3.91,0-3.23-2.26-5.16-6.76-5.79v11.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M347.48,244.88c-16.8,0-30.47-13.67-30.47-30.47s13.67-30.47,30.47-30.47,30.47,13.67,30.47,30.47-13.67,30.47-30.47,30.47Zm0-56.29c-14.24,0-25.82,11.58-25.82,25.82s11.58,25.82,25.82,25.82,25.82-11.58,25.82-25.82-11.58-25.82-25.82-25.82Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 513.67,
    y: 523.94,
    width: 27.84,
    height: 52.72,
    transform: "translate(-232.26 488.58) rotate(-41.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 501.95,
    y: 528.39,
    width: 27.84,
    height: 17.39,
    transform: "translate(-226.44 477.47) rotate(-41.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 551.2,
    y: 547.33,
    width: 48.75,
    height: 114.19,
    transform: "translate(-256.09 534.05) rotate(-41.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 554.42,
    y: 555.4,
    width: 24.14,
    height: 114.19,
    transform: "translate(-263.73 530.06) rotate(-41.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 591.86,
    y: 645.93,
    width: 48.75,
    height: 8.71,
    transform: "translate(-276.27 572.54) rotate(-41.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 511.45,
    y: 555.27,
    width: 48.75,
    height: 8.67,
    transform: "translate(-236.35 496.31) rotate(-41.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M439.89,313.87c-71.14-4.27-132.28,49.94-136.55,121.08-4.27,71.14,49.95,132.28,121.08,136.55,71.15,4.27,132.28-49.94,136.55-121.08,4.27-71.14-49.93-132.28-121.08-136.55Zm84.66,197.57c-37.97,51.04-110.12,61.62-161.15,23.65-51.02-37.98-61.62-110.12-23.64-161.16,37.99-51.03,110.13-61.61,161.17-23.64,51.03,37.97,61.6,110.12,23.63,161.15Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M439.07,327.63c-63.54-3.81-118.14,44.6-121.96,108.14-3.82,63.54,44.6,118.14,108.14,121.95,63.54,3.82,118.14-44.6,121.96-108.14,3.82-63.54-44.6-118.14-108.14-121.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M439.07,327.63c-35.52-2.13-68.26,12.07-90.88,36.1,20.95-15.44,47.23-23.92,75.24-22.24,63.55,3.81,111.96,58.42,108.14,121.96-1.68,28.01-13.24,53.08-31.08,72.03,26.57-19.58,44.58-50.37,46.72-85.9,3.82-63.54-44.6-118.14-108.14-121.96Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M366.56,379.11c19.48,1.17,33.59,30.11,31.52,64.63-2.07,34.52-19.55,61.56-39.03,60.39-19.48-1.17-33.6-30.11-31.52-64.62,2.07-34.52,19.55-61.56,39.03-60.39Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoListingFound);
export default __webpack_public_path__ + "static/media/no-listing-found.583f79ef6e8786eab3c1120d4afb40b7.svg";
export { ForwardRef as ReactComponent };